import { render, staticRenderFns } from "./VideoInline.vue?vue&type=template&id=72bd861e&"
import script from "./VideoInline.vue?vue&type=script&lang=js&"
export * from "./VideoInline.vue?vue&type=script&lang=js&"
import style0 from "./VideoInline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports